import { render, staticRenderFns } from "./overview-cell-breadcrumb.vue?vue&type=template&id=4c5403fa&scoped=true"
import script from "./overview-cell-breadcrumb.vue?vue&type=script&lang=ts"
export * from "./overview-cell-breadcrumb.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5403fa",
  null
  
)

export default component.exports